import React from 'react';

/* Responsive photo with the site's disclosure caption. `src` is the path without the -800/-1600.webp suffix. */
export const PagePhoto = ({src, alt, width = 1600, height = 900, caption = 'AI-generated illustration', className = '', eager = false, sizes = '(max-width: 900px) calc(100vw - 40px), 50vw', position, testid}) => (
  <figure className={`sp-photo ${className}`} data-testid={testid}>
    <img src={`${src}-800.webp`} srcSet={`${src}-800.webp 800w, ${src}-1600.webp 1600w`} sizes={sizes} width={width} height={height} alt={alt} loading={eager ? 'eager' : 'lazy'} fetchPriority={eager ? 'high' : undefined} decoding="async" style={position ? {objectPosition: position} : undefined}/>
    {caption && <figcaption>{caption}</figcaption>}
  </figure>
);
